import { AutomobileFormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/types/AutomobileFormItem';
import { parseVehicleAmount } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/utils/editVehicleLiveSummaryFormatters';
import { normalizeDate } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/maps/vehicleModificationPreview.map';
import { isDeepEqual } from '@/utils/isObjectDeepEqual';

interface FieldChangeState {
  isChangedFromInitial: boolean;
  isChangedSinceConfirmation: boolean;
}

const toVehicleAmountInput = (value: string | number | null | undefined): string | undefined =>
  value == null ? undefined : String(value);

export const getVehicleAmountChangeState = (
  initialPrice: string | number | null | undefined,
  currentPrice: string | number | null | undefined,
  confirmedPrice: string | number | null | undefined,
): FieldChangeState => {
  const initialVehicleAmount = parseVehicleAmount(toVehicleAmountInput(initialPrice));
  const currentVehicleAmount = parseVehicleAmount(toVehicleAmountInput(currentPrice));
  const confirmedVehicleAmount = parseVehicleAmount(toVehicleAmountInput(confirmedPrice));
  const isChangedFromInitial = initialVehicleAmount !== currentVehicleAmount;

  return {
    isChangedFromInitial,
    isChangedSinceConfirmation: currentVehicleAmount !== confirmedVehicleAmount,
  };
};

export const getRegistrationDateChangeState = (
  initialRegistrationDate: Date | string | null | undefined,
  currentRegistrationDate: Date | string | null | undefined,
  confirmedRegistrationDate: Date | string | null | undefined,
): FieldChangeState => {
  const initialDate = normalizeDate(initialRegistrationDate);
  const currentDate = normalizeDate(currentRegistrationDate);
  const confirmedDate = normalizeDate(confirmedRegistrationDate);
  const isChangedFromInitial = initialDate !== currentDate;

  return {
    isChangedFromInitial,
    isChangedSinceConfirmation: currentDate !== confirmedDate,
  };
};

export const isAutomobileFormItemDirty = (
  initialFormItem: AutomobileFormItem,
  currentItem: AutomobileFormItem | undefined,
): boolean => {
  const initialRegistrationDate = normalizeDate(initialFormItem.registrationDate);
  const currentRegistrationDate = normalizeDate(currentItem?.registrationDate);

  return !isDeepEqual(
    {
      ...initialFormItem,
      registrationDate: initialRegistrationDate,
    },
    {
      ...currentItem,
      registrationDate: currentRegistrationDate,
    },
  );
};
